import { Box } from "@mui/system";
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";

interface BrandSearchBarProps {
  dataTrackerForSearch: string;
  brandNames: string[];
  chosenBrand: string | null;
  onBrandChange: (value: string) => void;
  dataTrackerForDownload: string;
  onDownload?: () => void;
  disabled?: boolean;
  label?: string;
  width?: number;
}

const BrandSearchBar = ({
  dataTrackerForSearch,
  brandNames,
  chosenBrand,
  onBrandChange,
  dataTrackerForDownload,
  onDownload,
  disabled = false,
  label = "Brand Name",
  width = 350,
}: BrandSearchBarProps) => {
  return (
    <Box display="flex" alignItems="end" justifyContent="flex-end">
      <Autocomplete
        fullWidth
        disabled={disabled}
        disablePortal
        freeSolo
        forcePopupIcon
        data-tracker={dataTrackerForSearch}
        sx={{
          width,
          "& .MuiAutocomplete-clearIndicator": {
            visibility: chosenBrand ? "visible" : "hidden",
          },
        }}
        options={brandNames}
        value={chosenBrand || ""}
        disableClearable={!chosenBrand}
        onInputChange={(_, newVal) => onBrandChange(newVal ?? "")}
        onChange={(_, newValue: string | null) => onBrandChange(newValue ?? "")}
        getOptionLabel={(opt) => opt || ""}
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            color="secondary"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ marginLeft: "12px" }} />
                </InputAdornment>
              ),
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                const inputValue = (e.target as HTMLInputElement).value.trim();
                if (inputValue) {
                  onBrandChange(inputValue);
                  (e.target as HTMLInputElement).blur();
                }
              }
            }}
          />
        )}
      />
      <IconButton
        data-tracker={dataTrackerForDownload}
        aria-label="download"
        color="secondary"
        sx={{ ml: 2 }}
        onClick={onDownload}
        disabled={disabled}
      >
        <DownloadIcon />
      </IconButton>
    </Box>
  );
};

export default BrandSearchBar;
